import Vue from 'vue'
import Vuex from 'vuex'
import purchases from './modules/purchases'
import items from './modules/items'
import accounts from './modules/accounts'
import receives from './modules/receives'
import purchasesSimulation from './modules/purchases-simulation'
import auth from './modules/auth'
import materialJournals from './modules/material-journals'
import warehouses from './modules/warehouses'
import contracts from './modules/contracts'
import deliveries from './modules/deliveries'
import inventory from './modules/inventory'
import transactions from './modules/transactions'
import configs from './modules/configs'
import roles from './modules/roles'
import users from './modules/users'
import statistics from './modules/statistics'
import fiscalYears from './modules/fiscal-years'
import productionJournals from './modules/production-journals'

Vue.use(Vuex)

export default new Vuex.Store({
	actions: {
		reset({ dispatch }) {
			dispatch('auth/reset');
			dispatch('items/reset');
			dispatch('accounts/reset');
			dispatch('materialJournals/reset');
			dispatch('configs/reset');
			dispatch('receives/reset');
			dispatch('inventory/reset');
			dispatch('roles/reset');
			dispatch('users/reset');
		}
	},
	modules: {
		auth,
		purchases,
		items,
		accounts,
		receives,
		purchasesSimulation,
		productionJournals,
		materialJournals,
		warehouses,
		contracts,
		deliveries,
		inventory,
		statistics,
		transactions,
		configs,
		roles,
		users,
		fiscalYears
	}
})
